import React from 'react';
import { Box } from '@material-ui/core';
import { useQueryClient } from 'react-query';
import { makeStyles } from '@material-ui/core/styles';
import { Title } from 'components/layout/Title';
import { Button } from 'components/ui/Button/Buttons';
import { EQueryConst } from 'features/service/config';
import { UserInfoWithLzPzus } from 'api';
import { rolesRedirect } from 'common/utils/roles';

const useStyle = makeStyles(theme => ({
  root: {
    textAlign: 'center',
    width: 340,
  },
  title: {
    fontSize: 68,
    lineHeight: '68px',
    fontFamily: 'SBSansText-Regular',
    fontWeight: 700,
    color: '#333',
    marginBottom: 32,
    [theme.breakpoints.down('sm')]: {
      marginTop: 12,
    },
  },
  description: {
    fontFamily: 'SBSansText-Regular',
    fontSize: 17,
    marginBottom: 32,
  },
  subDescription: {
    fontSize: 17,
    fontFamily: 'SBSansText-Regular',
    color: theme.palette.text.secondary,
    marginBottom: 32,
  },
  container: {
    [theme.breakpoints.down('sm')]: {
      height: '100%',
    },
  },
}));

const NotFound = () => {
  const classes = useStyle();
  const queryClient = useQueryClient();
  const user = queryClient.getQueryData(EQueryConst.CURRENT_USER) as UserInfoWithLzPzus;
  const redirect = () => rolesRedirect(user);

  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      height='calc(100% - 120px)'
      width='100%'
      className={classes.container}
    >
      <Box className={classes.root}>
        <Title className={classes.title}>404</Title>
        <p className={classes.description}>По вашему запросу ничего не найдено.</p>
        <p className={classes.subDescription}>Вы можете вернуться в систему нажав на кнопку ниже</p>
        <Button variant='contained' fullWidth onClick={() => redirect()}>
          Вернуться в систему
        </Button>
      </Box>
    </Box>
  );
};

export default NotFound;
